












































































































































































































import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {Http} from '@/decorators';
import {httpService} from '@/services';
import {AxiosResponse} from 'axios';
import KendoChart from '@/components/kendo-chart/kendo-chart.vue';
import {CONFIG} from '@/config';
import {REPORT_GET_REPORTS} from '@/modules/neodash/store/modules/report/types';
import ReportLegend from '@/modules/neodash/components/report-legend/report-legend.vue';
import {PRINT_GET_PRINT_MODE} from '@/store/modules/print/types';
import * as moment from 'moment';

@Component({
  components: {
    KendoChart,
    ReportLegend
  }
})
export default class MarketBreakDownRegistration extends Vue {
  numeral = numeral;

  @Prop({required: true})
  public dataQuery: any;

  @Getter(REPORT_GET_REPORTS)
  reports: any;
  @Getter(PRINT_GET_PRINT_MODE)
  printMode: any;

  public clientName: string;
  public locality: string;
  public localityTitle: string;
  public typeSales: string;

  public state: any = {
    dataSource: [],
    requestData: {},
    client: ''
  };

  @Watch('dataQuery')
  public requestData() {
    this.typeSales = this.getTypeSales(parseInt(this.dataQuery.tipo_venda.value));
    this.state.requestData = {
      LevelLocality: this.dataQuery.nivel_localidade.value,
      TypeLocality: this.dataQuery.tipo_localidade.value,
      SalesType: this.dataQuery.nivel_localidade.value == -1 ? this.dataQuery.tipo_venda.value : 3,
      EndYear: this.dataQuery.ano_fim.value,
      EndMonth: this.dataQuery.mes_final.value,
      StartYear: this.dataQuery.ano_inicio.value,
      StartMonth: this.dataQuery.mes_inicial.value,
      GeoCodigos: [],
      Name: this.dataQuery.name
    };

    if (String(this.dataQuery.nivel_localidade.value) !== '-1')
      this.state.requestData.GeoCodigos = [this.dataQuery.localidade_cliente.value];

    this.localityTitle = this.dataQuery.tipo_localidade.text;

    this.locality =
        String(this.dataQuery.nivel_localidade.value) === '-1'
            ? this.dataQuery.tipo_localidade.text
            : `${this.dataQuery.localidade_cliente.text} ${this.dataQuery.tipo_localidade.text}`;

    httpService.http
        .post(`${CONFIG.URL.NEODASH_API}/api/gigdash/marketBreakDown/getAnalysisPMA`, this.state.requestData)
        .then((res: AxiosResponse) => {
          this.state.dataSource = _.cloneDeep(
              _(res.data.analysis)
                  .filter(f => f.relatorio === 1)
                  .map(f => f)
                  .value()
          );
          this.clientName = res.data.clientName;
        });
  }

  public capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  public getTypeSales(type) {
    switch (type) {
      case 1:
        return 'Retail';
      case 2:
        return 'Direct Sales';
      case 3:
        return 'Total';
      default:
        return '';
    }
  }

  public getPeriod() {
    const start = new Date(this.dataQuery.ano_inicio.value, this.dataQuery.mes_inicial.value - 1, 1);
    const end = new Date(this.dataQuery.ano_fim.value, this.dataQuery.mes_final.value - 1, 1);

    return {
      start: this.capitalize(moment(start).format('MMM YYYY')),
      end: this.capitalize(moment(end).format('MMM YYYY'))
    };
  }

  public get models() {
    if (!_.size(this.state.dataSource)) {
      return [];
    }
    return this.state.dataSource;
  }

  public get industyRetailChart() {
    return _(this.models)
        .filter(f => f.desc_rel === 'Total Industria')
        .map(f => {
          return {
            name: f.nm_pma,
            total: f.valor
          };
        })
        .orderBy(f => f.name)
        //   .reverse()
        .map(f => f)
        .value();
  }

  public get clientRetailChart() {
    return _(this.models)
        .filter(f => f.desc_rel === 'Total Cliente')
        .map(f => {
          return {
            name: f.nm_pma,
            total: f.valor
          };
        })
        .orderBy(f => f.name)
        //   .reverse()
        .map(f => f)
        .value();
  }

  public get marketShareChart() {
    return _(this.models)
        .filter(f => f.desc_rel === 'Market Share')
        .map(f => {
          return {
            name: f.nm_pma,
            total: f.valor
          };
        })
        .orderBy(f => f.name)
        //   .reverse()
        .map(f => f)
        .value();
  }

  public get outletsChart() {
    return _(this.models)
        .filter(f => f.desc_rel === 'Outlets' || f.desc_rel === 'Outlets Industria')
        .map(f => {
          return {
            name: f.nm_pma,
            total: f.desc_rel === 'Outlets' ? f.valor : 0,
            total_industria: f.desc_rel === 'Outlets Industria' ? f.valor : 0
          };
        })
        .flatten()
        .groupBy(f => f.name)
        .map((f, key) => {
          return {
            name: key,
            total: _.sumBy(f, 'total'),
            total_industria: _.sumBy(f, 'total_industria')
          };
        })
        .orderBy(f => f.name)
        //   .reverse()
        .map(f => f)
        .value();
  }

  public created() {
    this.requestData();
  }
}
